import { render, staticRenderFns } from "./CommitteeAbsenceRecorder.vue?vue&type=template&id=fc5d60e4&scoped=true"
import script from "./CommitteeAbsenceRecorder.vue?vue&type=script&lang=js"
export * from "./CommitteeAbsenceRecorder.vue?vue&type=script&lang=js"
import style0 from "./CommitteeAbsenceRecorder.vue?vue&type=style&index=0&id=fc5d60e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5d60e4",
  null
  
)

export default component.exports